module.exports = __webpack_public_path__ + "img/checkbox_marker.0812f420.svg";